import { useState, useEffect } from "react";
import {  loadBillOfMaterialPlanCode } from "../services/billOfMaterialService";

const useBillOfMaterialPlanCode = (editID) => {
    const [materialPlanCode, setMaterialPlanCode] = useState([]);    
    const [isMaterialCodeDataLoaded, setIsMaterialCodeDataLoaded] = useState(false);

    // Fetch department data
    const fetchMaterialCode = async (selectedID = null) => {
        const para = { p_companyid: localStorage.getItem("companyid") };

        try {
            const data = await loadBillOfMaterialPlanCode(para);
            if (data && data.length > 0) {
                setMaterialPlanCode(data[0].bom_code);         

            }
        } catch (error) {
            // CallMessage("error", error.message, "Error");
        }
    };

    // Load departments when the component mounts
    useEffect(() => {
        if (!isMaterialCodeDataLoaded && editID === 0) {
            fetchMaterialCode();
        }
    }, [isMaterialCodeDataLoaded, editID]);

    // Function to load department based on selected ID
    const loadMaterialPlanCodeByID = async (selectedID) => {        
        await fetchMaterialCode(selectedID);
    };

    return {
        materialPlanCode,
        setMaterialPlanCode,        
        loadMaterialPlanCodeByID,
    };
};

export default useBillOfMaterialPlanCode;
